import { render, staticRenderFns } from "./guardian-manager.vue?vue&type=template&id=6566d1bd"
import script from "./guardian-manager.ts?vue&type=script&lang=js&external"
export * from "./guardian-manager.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports